import { render, staticRenderFns } from "./DialogUserTable.vue?vue&type=template&id=48cef167&scoped=true&"
import script from "./DialogUserTable.vue?vue&type=script&lang=js&"
export * from "./DialogUserTable.vue?vue&type=script&lang=js&"
import style0 from "./DialogUserTable.vue?vue&type=style&index=0&id=48cef167&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cef167",
  null
  
)

export default component.exports